import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useScrollVisibility } from '../../../hooks/useScrollVisibility';
import HamburgerMenu from './../../../assets/img/icon/hamburger-menu.svg';
import HeaderLogo from '../../logo';
import Style from './style.module.scss';

const DesktopMenu = ({ onOpenMenu, currentLang, isActiveRoute, switchLanguage, routes }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const sticky = useScrollVisibility();

  return (
    <header
      className={clsx(Style.header, {
        [Style.homeHeader]: pathname === '/',
        [Style.sticky]: sticky,
      })}
    >
      <div className={Style.container}>
        <HeaderLogo />

        <nav className={Style.desktopNav}>
          {routes.map((item) => {
            const isActive = isActiveRoute(item, pathname);
            return (
              <Link
                key={item.key}
                to={item.route}
                className={clsx({ [Style.activeLink]: isActive })}
              >
                {item.title}
              </Link>
            );
          })}

          <div className={Style.lang}>
            <span
              className={clsx({ [Style.active]: currentLang === 'tr' })}
              onClick={() => switchLanguage('tr', i18n, pathname, navigate)}
            >
              TR
            </span>{' '}
            |{' '}
            <span
              className={clsx({ [Style.active]: currentLang === 'en' })}
              onClick={() => switchLanguage('en', i18n, pathname, navigate)}
            >
              EN
            </span>
          </div>
        </nav>

        <button className={Style.hamburger} onClick={onOpenMenu}>
          <img src={HamburgerMenu} alt={'hambuger'} />
        </button>
      </div>
    </header>
  );
};

export default DesktopMenu;
